import { render, staticRenderFns } from "./dottedLineBox.vue?vue&type=template&id=0622db5f&"
import script from "./dottedLineBox.vue?vue&type=script&lang=js&"
export * from "./dottedLineBox.vue?vue&type=script&lang=js&"
import style0 from "./dottedLineBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports